module.exports = __webpack_public_path__ + "static/media/low.a2d06cff.svg";